import React from 'react';
import { DataForEdit, UserProfileContainer } from '../../Styles/UserProfile';
import { IUser } from '../../Interfaces/IUser';
import { withTranslation, WithTranslation } from 'react-i18next';
import { editIcon } from '../../../../Assets/images/Icons';
import { SecondaryModernButton } from '../../../../__core/Styles/Buttons/SecondaryModernButton';
import ChangePasswordForm from './ChangePasswordForm';
import ChangeUsernameForm from './ChangeUsernameForm';
import { RouteComponentProps, withRouter } from 'react-router-dom';
import {
  GITHUB_ACCOUNT_LINKED,
  GITHUB_ACCOUNT_LINKED_PREFIX,
} from '../../../CourseInstance/Constraints';
import AppConfig from '../../../../Configs/AppConfig';
import { LogoutButton, LogoutSection } from '../../Styles/NavBar';
import { getBaseUrlForRedirect } from '../../../../__core/Utils/GetBaseUrl';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPowerOff } from '@fortawesome/free-solid-svg-icons';

type UserProfileProps = {
  user: IUser;
  refreshUserData: () => void;
} & WithTranslation &
  RouteComponentProps;

type UserProfileState = {
  showChangePasswordForm: boolean;
  showChangeUsernameForm: boolean;
};

class UserProfile extends React.Component<UserProfileProps, UserProfileState> {
  state = {
    showChangePasswordForm: false,
    showChangeUsernameForm: false,
  };

  toggleShowChangePasswordForm = (): void =>
    this.setState((state) => ({
      showChangePasswordForm: !state.showChangePasswordForm,
    }));

  closeChangePasswordForm = (): void =>
    this.setState({ showChangePasswordForm: false });

  toggleShowChangeUsernameForm = (): void =>
    this.setState((state) => ({
      showChangeUsernameForm: !state.showChangeUsernameForm,
    }));

  closeChangeUsernameForm = (): void =>
    this.setState({ showChangeUsernameForm: false });

  showGitHubSuccessAlert = (): boolean => {
    const {
      history: { location },
    } = this.props;
    const { hash } = location;

    return hash === GITHUB_ACCOUNT_LINKED;
  };

  render(): React.ReactElement {
    const { showChangePasswordForm, showChangeUsernameForm } = this.state;
    const {
      user: { name, surname, email, github, showGithubWarning, id: userId },
      refreshUserData,
      t,
      location,
    } = this.props;

    const passwordMask = '***********';

    return (
      <UserProfileContainer>
        <DataForEdit>
          <div>
            <div className="label">{t('Name and surname')}</div>
            <div className="value">{`${name} ${surname}`}</div>
          </div>
        </DataForEdit>

        <ChangeUsernameForm
          userId={userId}
          show={showChangeUsernameForm}
          closeForm={this.closeChangeUsernameForm}
          refreshUserData={refreshUserData}
        />

        <DataForEdit>
          <div>
            <div className="label">{t('E-mail')}</div>
            <div className="value">{email}</div>
          </div>
        </DataForEdit>

        <DataForEdit>
          <div>
            <div className="label">{t('Password')}</div>
            <div className="value">{passwordMask}</div>
          </div>
          <div className="icon" onClick={this.toggleShowChangePasswordForm}>
            {editIcon}
          </div>
        </DataForEdit>

        <ChangePasswordForm
          show={showChangePasswordForm}
          userId={userId}
          closeForm={this.closeChangePasswordForm}
        />

        <DataForEdit>
          <div>
            <div className="label">{t('Github')}</div>
            {github ? (
              <div className="value">{github}</div>
            ) : (
              <div className="value error">{t('Not linked')}</div>
            )}
          </div>
        </DataForEdit>

        <div>
          {!github && (
            <DataForEdit>
              <SecondaryModernButton
                as="a"
                href={`${
                  AppConfig.LOGIN_REDIRECT_URL
                }${GITHUB_ACCOUNT_LINKED_PREFIX}/${location.pathname.substring(
                  1
                )}`}
              >
                {t('Link accounts')}
              </SecondaryModernButton>
            </DataForEdit>
          )}
          {showGithubWarning && (
            <DataForEdit>
              <div>
                <div className="label">
                  {t(
                    'Link your GitHub account to Coders Lab profile to be able to solve the exercise and proceed the exam'
                  )}
                </div>
              </div>
            </DataForEdit>
          )}
        </div>
        {this.showGitHubSuccessAlert() && (
          <DataForEdit>
            <div>
              <div className="label positive">
                {t(
                  'Your account has been linked to Github. Now you will have access to the materials.'
                )}
              </div>
            </div>
          </DataForEdit>
        )}

        <LogoutSection>
          <LogoutButton
            id="logout-button"
            as="a"
            href={`${getBaseUrlForRedirect()}/byebye`}
          >
            <FontAwesomeIcon icon={faPowerOff} /> {t('Logout')}
          </LogoutButton>
        </LogoutSection>
      </UserProfileContainer>
    );
  }
}

export default withTranslation()(withRouter(UserProfile));
